import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { CampaignFolderSchema } from '../../../../../../schemas/CampaignFolderSchema'
import axiosService from '../../../../../../utils/AxiosService'
import Input from '../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import Modal from '../../../../../Modal/Modal'

export default observer(function EditFolderModal({ campaignFolder, open, setOpen, toggleDropdown }) {
  const { campaignState, campaignFolders } = useContext(CampaignContext)
  const { id } = useParams()

  const editFolder = campaign_folder => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_folders/${campaignFolder.id}`, { campaign_folder })
    .then(updatedFolder => {
      campaignState.campaignFolders = campaignFolders.map(folder => folder.id === updatedFolder.id ? updatedFolder : folder)
      toggleDropdown()
      setOpen(false)
      toastSuccess('Folder updated')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <Modal isOpen={open} onClose={() => setOpen(false)}>
      <Modal.Header>Edit Folder</Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={CampaignFolderSchema}
          initialValues={{ name: campaignFolder.name }}
          onSubmit={editFolder}
        >
          {({ handleBlur, handleChange, values, errors, touched }) => (
            <Form>
              <div className="form-item-container w-full">
                <Input autoFocus error={touched.name && errors.name} placeholder="Name" name='name' onChange={handleChange} onBlur={handleBlur} value={values.name} />
                <button
                  type="submit"
                  className="bg-rb-green text-white px-4 py-2 rounded-2xl w-full mt-4 dark:text-rb-dark-mode"
                >
                  Update Folder
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
})